import { cn } from '@/shared/utils/cn';

type ChartContainerProps = {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
};

export const ChartContainer = ({
  title,
  subtitle,
  action,
  className,
  children,
}: ChartContainerProps) => {
  return (
    <div
      className={cn(
        'bg-white rounded-lg border border-gray-200 p-6',
        className,
      )}
    >
      <div className="flex items-start justify-between mb-6">
        <div>
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
          {subtitle && (
            <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
          )}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
      {children}
    </div>
  );
};
